/* globals sectionHeading, sectionSubHeading, resetbtnText, nextbtnText, prevbtnText */
/* globals resultOverviewText */
/* eslint max-lines: ["error", 500] */

(function ($) {
    'use strict';
    var QuestionBox = function (el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$questions = this.$el.find('.question-box-item');
        this.$steps = this.$el.find('.question-box-step-indicator');
        this.$submit = this.$el.find('.field-submit');
        this.$reset = this.$el.find('.question-box-reset');
        this.$result = this.$el.find('.question-box-result');
        this.$checkBtn = this.$el.find('.btn-check-next');
        this.settings = $.extend(
            {
                speed: 200,
                layout: 'steps',
                showAll: false,
                optional: false
            },
            this.settings,
            this.$el.data()
        );
        this.init();
    };
    QuestionBox.prototype = {
        currentIndex: 0,
        nextIndex: 0,
        nextStepIndex: 0,
        numberOfQuestions: 0,
        productIds: '',
		isLastAns: false,
        init: function () {
            var that = this;
            that.numberOfQuestions = that.$questions.length;
            that.fillContent();
            that.bindEvents();
            that.checkQuestionForCheckboxes();
            if (that.settings.layout === 'no-steps' && !that.settings.showAll) {
                that.addNavButtons();
            }
            if (that.settings.optional) {
                that.$checkBtn.removeClass('btn-hide');
                that.$checkBtn.removeClass('btn-inactive');
                that.$questions.find('.field').each(function () {
                    $(this).addClass('no-continue');
                });
                that.$el.find('.question-box-step').each(function () {
                    $(this).addClass('clickable');
                });
            }
            that.activateSubmit();
        },
        fillContent: function () {
            if (
                typeof sectionHeading !== 'undefined' &&
                $('#sectionHeading') !== 'undefined'
            ) {
                $('#sectionHeading').html(sectionHeading);
            }
            if (
                typeof sectionSubHeading !== 'undefined' &&
                $('#sectionSubHeading') !== 'undefined'
            ) {
                $('#sectionSubHeading').html(sectionSubHeading);
            }
            if (
                typeof resetbtnText !== 'undefined' &&
                $('#resetbtnText') !== 'undefined'
            ) {
                $('#resetbtnText').html(resetbtnText);
            }
            if (typeof nextbtnText !== 'undefined' && $('#nextbtnText') !== 'undefined') {
                $('#nextbtnText').html(nextbtnText);
            }
        },
        bindEvents: function () {
            var that = this;
            that.$el.parents('.form').unbind('submit');
            that.$steps.on('click', function () {
                var $step = $(this);
                if ($step.parent().hasClass('active')) {
                    return;
                }
                that.nextIndex = $step.data('question');
                that.$steps.parent().removeClass('active');
                $step.parent().addClass('active');
                that.showQuestion();
            });
            that.$questions.find('input').on('click', function () {
                var $currentAnswers = that.$el.find('.qa-' + (that.currentIndex + 1));
                var anyChecked = false;
                $currentAnswers.each(function () {
                    var $answer = $(this);
                    if ($answer.is(':checked')) {
                        that.productIds = $answer.attr('data-productids');
						anyChecked = true;
						if($answer.attr('data-islastans') === 'true')
						{
							that.isLastAns=true;  
						}
						else
						{
							that.isLastAns=false;  
						} 	
                    }
                });
                if (anyChecked && that.currentIndex !== that.$questions.size() - 1) {
                    that.$el.find('.btn-check-next').removeClass('btn-inactive');
                } else if (
                    !that.$el.find('.btn-check-next').hasClass('btn-inactive') &&
                    !that.settings.optional
                ) {
                    that.$el.find('.btn-check-next').addClass('btn-inactive');
                }
                that.$steps.eq(that.nextIndex).parent().addClass('done');
                that.activateSubmit();
                if (
                    that.$questions.has('.no-continue').length < 1 &&
                    !that.settings.optional
                ) {
                    that.nextQuestion();
                }
            });
            that.$questions.on('click', '.btn-next', function () {
                if (!$(this).hasClass('btn-inactive')) {
                    that.nextQuestion();
                }

                return false;
            });
            that.$el.on('click', '.btn-check-next', function () {
                if (!$(this).hasClass('btn-inactive')) {
                    that.nextQuestion();
                }

                return false;
            });
            that.$questions.on('click', '.btn-prev', function () {
                if (!$(this).hasClass('btn-inactive')) {
                    that.nextIndex = parseInt(
                        that.$questions.eq(that.currentIndex).attr('data-PrevIndex')
                    );
                    that.showQuestion();
                }

                return false;
            });
            that.$reset.on('click', function (e) {
                e.preventDefault();
                that.resetQuestions();
            });
            that.$submit.on('click', function (e) {
                if (
                    that.allAnswered() === false ||
                    that.$submit.hasClass('btn-inactive')
                ) {
                    e.preventDefault();
                }
            });
        },
        nextQuestion: function () {
            var that = this;
            if (that.settings.layout === 'no-steps' && !that.settings.showAll) {
                that.$questions
                    .eq(that.currentIndex)
                    .find('.btn-next')
                    .removeClass('btn-inactive')
                    .fadeIn(500);
            }
            if (that.currentIndex <= that.numberOfQuestions) {
                var nextDivId = that.$questions
                    .eq(that.currentIndex)
                    .find(':checked')
                    .val();
                that.nextStepIndex = that.$questions.index($('#' + nextDivId));
                $('#' + nextDivId).attr('data-PrevIndex', that.currentIndex);
                that.nextIndex = that.nextStepIndex;
                that.showQuestion();
                that.$steps
                    .parent()
                    .removeClass('active')
                    .eq(that.nextIndex)
                    .addClass('active');
            }
            if (
                that.$questions.eq(that.currentIndex).find(':checked').length === 0 &&
                !that.settings.optional
            ) {
                that.$checkBtn.addClass('btn-inactive');
            }
        },
        addNavButtons: function () {
            var that = this,
                $wrapper = $('<div>').addClass('question-box-nav'),
                $next = $('<a>')
                    .addClass('btn btn-no-icon btn-inactive btn-next')
                    .text(nextbtnText)
                    .hide(),
                $prev = $('<a>')
                    .addClass('btn btn-no-icon btn-inverted btn-prev')
                    .text(prevbtnText),
                $submit = that.$el.find('.question-box-submit').remove(),
                $question,
                $wrapperClone;
            $('<a>').addClass('question-box-reset').text(resultOverviewText);
            that.$questions.each(function (index) {
                $question = $(this);
                $wrapperClone = $wrapper.clone();
                $question.append($wrapperClone);
                switch (index) {
                    case 0:
                        $wrapperClone.append($next.clone());
                        break;
                    case that.numberOfQuestions - 1:
                        $wrapperClone.append($prev.clone());
                        $wrapperClone.append($submit);
                        break;
                    default:
                        $wrapperClone.append($prev.clone());
                        $wrapperClone.append($next.clone());
                }
            });
            that.$navBar = $wrapper;
        },
        removeNavButtons: function () {
            var that = this;
            that.$questions.each(function () {
                $(this).find('.question-box-nav').remove();
            });
        },
        activateSubmit: function () {
            var that = this;
            if (that.allAnswered() || that.isLastAns || that.settings.optional) {
                that.$submit.removeClass('btn-inactive');
                if (this.$el.hasClass('question-box-product-finder')) {
					if(that.productIds)
					{
						that.getProductFinderData(function (err, data) {
							that.renderProductFinderResults(err, data);
						}, that.productIds);
					}
                }
            } else {
                that.$submit.addClass('btn-inactive');
            }
        },
        getProductFinderData: function (cb, articleNumbers) {
            var URL =
                $('#hdnDomain').val() +
                '/TCWServices/TCWService.svc/GetProductDetails?articleNumber=' +
                articleNumbers +
                '&segmentId=' +
                $('#hdnSegmentId').val();
            $.ajax({
                type: 'GET',
                contentType: 'application/json; charset=UTF-8;',
                url: URL,
                dataType: 'json',
                async: false,
                success: function (data) {
                    cb(null, data);
                },
                error: function (error) {
                    cb(error);
                }
            });
        },
        renderProductFinderResults: function (err, data) {
            var that = this;
            var $questionsContainer = this.$el.find('.product-finder-questions');
            var $resetBox = this.$el.closest('.tab-content').find('.reset-btn-container');
            var $resultsContainer = this.$el.find('.product-finder-results');
            $questionsContainer.addClass('hide');
            if (err) {
            } else {
                $resultsContainer.empty();
                for (var index = 0; index < data.length; index++) {
                    // '/cgr/Products/Products/{0}/{1}';
                    var productUrlString = $('#hdnProductDetailPageUrl').val();
                    productUrlString = productUrlString.replace(
                        '{0}',
                        data[index].FamilyURLFriendlyName
                    );
                    productUrlString = productUrlString.replace(
                        '{1}',
                        data[index].URLFriendlyName
                    );
                    var img = data[index].AssetUrl,
                        imgAlt = '',
                        link = productUrlString,
                        title = data[index].LongName,
                        description =
                            data[index].DescriptionHeadlines &&
                            data[index].DescriptionHeadlines.length > 0
                                ? data[index].DescriptionHeadlines[0].Value
                                : '',
                        absorbencyLevel =
                            data[index].DoubleCategoryValue &&
                            data[index].DoubleCategoryValue.length > 0
                                ? data[index].DoubleCategoryValue[0].Value
                                : 0.0,
                        absorbencyItems = that.renderProductFinderAbLevel(
                            absorbencyLevel
                        ),
                        articleNumber = data[index].ArticleNumber,
                        html = [
                            '<a href="' +
                                link +
                                '" class="col-3 col-md-4 col-sm-6 col-xs-12 vspace-sm">',
                            '<div class="crate manual-padding">',
                            '<div class="crate-content">',
                            '<div class="component component-sample-box">',
                            '<div class="sample-box ">',
                            '<div class="sample-box-img">',
                            '<img src="' + img + '" alt="' + imgAlt + '">',
                            '</div>',
                            '<div class="sample-box-information">',
                            '<div data-reviewtype="Category" class="js-review" id="product' + articleNumber + index + '" data-pageid="' + articleNumber + '" ></div>',
                            '<div class="sample-box-details">',
                            '<h3 class="sample-box-title">' + title + '</h3>',
                            '<p>' + description + '</p>',
                            '<div class="product-details">',
                            '<div class="detail-rating">',
                            '<h4>'+window.labels.absorbencyText+'</h4>',
                            '<ul class="rating">',
                            absorbencyItems,
                            '</ul>',
                            '</div>',
                            '</div>',
                            '</div>',
                            '</div>',
                            '</div>',
                            '</div>',
                            '</div>',
                            '</div>',
                            '</a>'
                        ]
                            .join('')
                            .trim();
                    if (data[index].ArticleNumber !== null) {
                        $resultsContainer.append(html);
                    }
                }
                $resetBox.removeClass('hide');
                $resultsContainer.removeClass('hide');
                $resetBox.find('button').on('click', function (e) {
                    e.preventDefault();
                    that.resetAllQuestionBoxes();
                    $resultsContainer.addClass('hide');
                    $resetBox.addClass('hide');
                    $questionsContainer.removeClass('hide');
                });
                setUpRatingsandReviews();
            }
        },
        resetAllQuestionBoxes: function () {
            var that = this;
            that.resetQuestions();
            that.currentIndex = 0;
            that.removeNavButtons();
            that.addNavButtons();
            that.$questions.each(function (index, question) {
                $(question).removeClass('active').css('opacity', 0);
            });
            that.$questions.eq(0).addClass('active').css('opacity', 1);
        },
        // Passed a value of 0, 0.5, or >= 1, will return a string
        // representing that value, either 'half', 'full', or 'empty'
        renderProductFinderAbItem: function (val) {
            var className;

            if (val === 0.5) {
                className = 'half-full';
            } else if (val) {
                className = 'full';
            } else {
                className = 'empty';
            }

            return className;
        },
        // For a given level, and max level, render some HTML that represents that level.
        // The default max items is 8
        renderProductFinderAbLevel: function (level, max) {
            max = max || 8;
            var items = [];
            for (var index = 0; index <= max; index += 1) {
                items.push(
                    '<li><i class="icon-drop-' +
                        this.renderProductFinderAbItem(Math.max(0, level - index)) +
                        '"></i></li>'
                );
            }

            return items.join(' ');
        },
        showQuestion: function () {
            var that = this,
                $current = that.$questions.eq(that.currentIndex),
                $next = that.$questions.eq(that.nextIndex),
                currentAnim = { opacity: 0 };
            that.currentIndex = that.nextIndex;
            if (that.settings.showAll) {
                currentAnim = {};
            }
            $current.animate(currentAnim, that.settings.speed, function () {
                $current.removeClass('active');
                if (!that.settings.showAll) {
                    $next.css('opacity', 0).addClass('active').animate(
                        {
                            opacity: 1
                        },
                        that.settings.speed
                    );
                }
            });
            that.checkIfLastQuestion();
        },
        allAnswered: function () {
            var that = this;

            if (that.$questions.eq(that.currentIndex).attr('data-islast') === 'false') {
                return false;
            }

            return true;
        },
        resetQuestions: function () {
            var that = this;
            that.$questions.find('input').each(function () {
                $(this).attr('checked', false);
            });
            that.$result.removeClass('active');
            that.$questions.eq(0).addClass('active');
        },
        checkQuestionForCheckboxes: function () {
            var that = this;
            if (that.$questions.has('.no-continue').length > 0) {
                that.$el.find('.btn-check-next').show();
            }
            if (
                that.$questions.eq(that.currentIndex).find(':checkbox').length > 1 &&
                that.currentIndex === that.$steps.length - 1
            ) {
                that.activateSubmit();
                that.$el.find('.btn-check-next').hide();
            }
        },
        checkIfLastQuestion: function () {
            var that = this;
            var nextButton = that.$el.find('.btn-check-next');
            if (
                that.$questions.eq(that.currentIndex).find(':checkbox').length > 1 &&
                that.currentIndex === that.$steps.length - 1
            ) {
                that.activateSubmit();
                nextButton.addClass('btn-inactive');
            } else if (nextButton.hasClass('btn-inactive')) {
                nextButton.removeClass('btn-inactive');
            }
        }
    };
    $.fn.questionBox = function (options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function () {
            $this = $(this);
            data = $this.data('questionBox');
            if (!data) {
                $this.data('questionBox', (data = new QuestionBox(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.questionBox.Constructor = QuestionBox;
})(jQuery);
